<template>
    <div class="demo-inline-spacing">
        <Button
            v-if="isLifeCycleVisible"
            class="mt-0"
            @click="showLifeCycle"
        >
            {{ $t('Component(Button):request-life-cycle') }}
        </Button>
        <Button
            v-if="isExternalReplyVisible"
            class="mt-0"
            @click="externalReply"
        >
            {{ $t('Component(Button):external-response') }}
        </Button>
        <b-form-checkbox
            name="check-button"
            :value="true"
            switch
            inline
            v-if="false"
            @input="switchProductTabsVisibility"
        >
            Show product tabs
        </b-form-checkbox>
        <b-button
            v-if="saveVisible"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="save"
        >
            {{ $t('Component(Button):save') }}
        </b-button>
        <b-button
            v-if="resendEmailVisible"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            :title="resendEmailTitleAttributeText"
            @click="resendEmail"
        >
            {{ $t('Component(Button):resend-email') }}
        </b-button>
        <b-button
            v-if="approveVisible"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="approve"
        >
            {{ $t('Component(Button):approve') }}
        </b-button>
        <b-button
            v-if="partialApproveVisible"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="approvePartially"
        >
            {{ $t('Component(Button):approve-partially') }}
        </b-button>
        <b-button
            v-if="rejectVisible"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            class="mt-0"
            @click="reject"
        >
            {{ $t('Component(Button):reject') }}
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="close"
        >
            {{ $t('Component(Button):close') }}
        </b-button>
    </div>
</template>

<script>
import { BFormCheckbox, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Button from "@core/components/common/Button.vue";

export default {
    components: {
        Button,
        BFormCheckbox,
        BButton,
    },
    directives: {
        Ripple
    },
    props: {
        isExternalReplyVisible: {
            type: Boolean,
            default: false
        },
        saveVisible: {
            type: Boolean,
            default: false
        },
        resendEmailVisible: {
            type: Boolean,
            default: true,
        },
        approveVisible: {
            type: Boolean,
            default: false,
        },
        partialApproveVisible: {
            type: Boolean,
            default: false,
        },
        rejectVisible: {
            type: Boolean,
            default: false,
        },
        isLifeCycleVisible: {
            default: true
        },
        resendEmailTitleAttributeText: {
            default: ''
        }
    },
    methods: {
        externalReply() {
            this.$emit('externalReply')
        },
        showLifeCycle() {
            this.$emit('showLifeCycle')
        },
        switchProductTabsVisibility(show) {
            this.$emit('switchProductTabsVisibility', show);
        },
        close() {
            this.$emit('close');
        },
        save() {
            this.$emit('save');
        },
        approve() {
            this.$emit('approve');
        },
        approvePartially() {
            this.$emit('approvePartially');
        },
        reject() {
            this.$emit('reject');
        },
        resendEmail() {
            this.$emit('resendEmail')
        }
    }
}
</script>

<style scoped>

</style>
